import * as React from 'react';
import { getCatalogRegistration } from '@/redux/modules/catalog/registration/catalogRegistration.selectors';
import { getCountDown } from '@/redux/modules/bidCountDown';
import {
    getItemSummaryIsTimedAuction,
    getItemSummarySellerId,
} from '@/redux/modules/item/summary/itemSummary.selectors';
import { getLiveCatalogCurrentItemId, getLiveCatalogPaused } from '@/redux/modules/console';
import { useAppSelector } from '@/redux/hooks';
import AuctioneerDetails from '@/pages/BiddingConsole/components/AuctioneerDetails/AuctioneerDetails';
import BidCountDown from '@/components/BidCountDown/BidCountDown';
import ConsoleSocial from '@/components/ConsoleSocial/ConsoleSocial';
import CuratorInfo from '@/components/CuratorInfo/CuratorInfo';
import InlineLightboxCarousel from '@/pages/BiddingConsole/components/InlineLightboxCarousel/InlineLightboxCarousel';
import ItemDescription from '@/components/ItemDescription/ItemDescription';
import styled from 'styled-components';

type Props = {
    catalogId: number;
    className?: string;
};

const CurrentItemDetails = ({ catalogId, className }: Props) => {
    const itemId = useAppSelector((state) => getLiveCatalogCurrentItemId(state, catalogId));
    const catalogRegistration = useAppSelector((state) => getCatalogRegistration(state, catalogId));
    const auctionPaused = useAppSelector((state) => getLiveCatalogPaused(state, catalogId));
    const isTimedAuction = useAppSelector((state) => getItemSummaryIsTimedAuction(state, itemId));
    const sellerId = useAppSelector((state) => getItemSummarySellerId(state, itemId));
    const timeStamp = useAppSelector((state) => getCountDown(state, itemId));
    const showCountDown = isTimedAuction && Boolean(timeStamp) && catalogRegistration.approved;

    return (
        <CurrentItemContainer className={className}>
            <InlineLightboxCarousel
                catalogId={catalogId}
                itemId={itemId}
            />
            <StyledConsoleSocial
                isPaused={auctionPaused}
                itemId={itemId}
            />
            {showCountDown && (
                <CountDownContainer>
                    <BidCountDown timeStamp={timeStamp} />
                </CountDownContainer>
            )}
            <ItemDetailsContainer>
                <ItemDescription itemId={itemId} />
                <AuctioneerDetails
                    catalogId={catalogId}
                    sellerId={sellerId}
                />
                <CuratorInfo catalogId={catalogId} />
            </ItemDetailsContainer>
        </CurrentItemContainer>
    );
};

export default CurrentItemDetails;

const ItemDetailsContainer = styled.div`
    display: block;
    flex: 1 1 auto;
`;

const CountDownContainer = styled.div`
    display: block;
    padding: 0 20px;
    color: ${({ theme }) => theme.colors.grey100};
    flex: 0 0 21px;
    margin-top: 15px;
`;

const CurrentItemContainer = styled.section`
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    position: relative;
    overflow: auto;
    transition: all 0.2s ease-in;
    background: ${({ theme }) => theme.colors.white};
    padding: 0 0 24px 24px;
    &:hover {
        z-index: 15;
    }
`;

const StyledConsoleSocial = styled(ConsoleSocial)`
    left: 28px;
    top: 4px;
`;
